import { render } from "./Experiences-component.vue?vue&type=template&id=bb7b8d18&scoped=true"
import script from "./Experiences-component.vue?vue&type=script&lang=js"
export * from "./Experiences-component.vue?vue&type=script&lang=js"

import "./Experiences-component.vue?vue&type=style&index=0&id=bb7b8d18&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb7b8d18"]])

export default __exports__